import {
  MAX_CHARS_IN_ABOUT_MOBILE,
  MAX_LINES_IN_ABOUT,
} from '@utils/constants';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { AccountCertification } from '@wix/ambassador-academy-certifications-v1-account-certification/types';
import { Platforms } from '@wix/ambassador-partners-profile-v1-partner-profile/types';
import { Box, Heading } from '@wix/design-system';
import { FC } from 'react';
import ShowMoreText from '../../ShowMoreText';
import Certifications from '../Certifications';
import { shouldRenderCertifications } from '../Certifications/CertificationsUtils';
import Services from '../Services';
import { useHasServices } from '../Services/useHasServices';
import ContactDetails from './ContactDetails';
import s from './About.module.scss';

type Props = {
  about?: string | null;
  platforms?: Platforms;
  certifications: AccountCertification[];
  onShowLess?: () => void;
};

const AboutMobile: FC<Props> = ({
  about,
  platforms,
  certifications,
  onShowLess,
}) => {
  const { t } = useTranslation();
  const hasServices = useHasServices();
  const hasCertifications = shouldRenderCertifications(certifications);

  return (
    <Box direction="vertical" className={s.aboutMobile} width="100%" gap="12px">
      <Box
        dataHook="about-container"
        className={`${s.aboutContainer} ${s.mobile}`}
        direction="vertical"
        gap="24px"
      >
        <Heading size="medium" as="h2" dataHook="about-header">
          {t('profile-page-about-title')}
        </Heading>
        <ShowMoreText
          originalText={about}
          maxChars={MAX_CHARS_IN_ABOUT_MOBILE}
          maxLines={MAX_LINES_IN_ABOUT}
          textSize="medium"
          buttonWeight="thin"
          isMobileView={true}
          handleShowLessClick={onShowLess}
          showMoreButtonText={t(
            'profile-page-about-section-show-more-text-button',
          )}
          showLessButtonText={t(
            'profile-page-about-section-show-less-text-button',
          )}
        />
      </Box>

      {hasCertifications && (
        <Box direction="vertical" className={s.certificationsMobileContainer}>
          <Certifications
            isMobileView={true}
            variant="detailed"
            data={certifications}
          />
        </Box>
      )}

      {hasServices && (
        <Box direction="vertical" className={s.servicesMobileContainer}>
          <Services isMobileView={true} />
        </Box>
      )}

      <ContactDetails
        platforms={platforms}
        isMobileView={true}
        className={s.contactMobileContainer}
      />
    </Box>
  );
};

export default AboutMobile;
